import * as stylex from "@stylexjs/stylex";
import {
  badgeColW,
  badgeColH,
  barX,
  barY,
  barCellW,
  barHeight,
  checkDx,
  checkPath,
  checkLength,
} from "./softmax-curve";
import { styles } from "../onboarding.styles";
import { useStepBadge } from "./use-step-badge";

export function StepBadge({
  done,
  landing,
}: Readonly<{ done: boolean; landing: boolean }>) {
  const { levels, reduced, settling } = useStepBadge({ done, landing });
  return (
    <span
      aria-hidden="true"
      data-step-badge={done ? "done" : "active"}
      data-bar-frame={levels ? levels.join("") : undefined}
      {...stylex.props(
        styles.badge,
        done ? styles.doneBadge : styles.activeBadge,
      )}
    >
      <svg
        viewBox={`0 0 ${badgeColW} ${badgeColH}`}
        {...stylex.props(styles.svg)}
        preserveAspectRatio="xMidYMid meet"
      >
        {levels?.map((level, i) => (
          <rect
            key={i}
            x={barX(i)}
            y={barY(level)}
            width={barCellW}
            height={barHeight(level)}
            {...stylex.props(styles.bars)}
          />
        ))}
        {done && !settling ? (
          <g transform={`translate(${checkDx} 0)`}>
            <path
              d={checkPath}
              fill="none"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray={checkLength}
              {...stylex.props(
                styles.check,
                landing && !reduced && styles.drawCheck,
              )}
            />
          </g>
        ) : null}
      </svg>
    </span>
  );
}
